import styled from "@emotion/styled";

export const MainContentWrapper = styled("main")(() => ({
  marginLeft: 0,
  padding: "20px",
}));
export const MainContentMobileWrapper = styled("main")(() => ({
  marginLeft: 0,
  paddingTop: "64px",
  paddingLeft: "4px",
  paddingRight: "4px",
}));
